import {getField, updateField} from "vuex-map-fields";
import {getWinnerState} from "@/store/States";

const state = getWinnerState()

const getters = {
    getWinnerField(state) {
        return getField(state.form);
    },
    getSimpleField(state) {
        return getField(state.simple);
    },
    getPoolField(state) {
        return getField(state.pool);
    },
    getTotalField(state) {
        return getField(state.total);
    },
    getLineField(state) {
        return getField(state.line);
    },
    getSpreadField(state) {
        return getField(state.spread);
    },
    getBracketField(state) {
        return getField(state.bracket);
    },
}

const actions = {}

const mutations = {
    resetState(state) {
        Object.assign(state, getWinnerState())
    },
    setForm(state, form) {
        state.form.type = form.type
        Object.assign(state[form.type], form[form.type])
    },
    setBracketOrder(state, order) {
        state.bracket.bracketModel = order
    },
    updateWinnerField(state, field) {
        updateField(state.form, field);
    },
    updateSimpleField(state, field) {
        updateField(state.simple, field);
    },
    updatePoolField(state, field) {
        updateField(state.pool, field);
    },
    updateTotalField(state, field) {
        updateField(state.total, field);
    },
    updateLineField(state, field) {
        updateField(state.line, field);
    },
    updateSpreadField(state, field) {
        updateField(state.spread, field);
    },
    updateBracketField(state, field) {
        updateField(state.bracket, field);
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
